<template>
  <div class="row">
    <div class="col-12 py-3">
      <div class="btn-group float-end">
        <a type="button" class="btn btn-primary bg-gray" :class="{ 'active': filterType === 1 }"
          @click="setFilterType(1)"><i class="bx bx-filter-alt"></i> Status </a>
        <a type="button" class="btn btn-primary bg-gray" :class="{ 'active': filterType === 2 }"
          @click="setFilterType(2)"><i class="bx bx-filter-alt"></i> Pessoas </a>
        <a type="button" class="btn btn-primary bg-gray" :class="{ 'active': filterType === 3 }"
          @click="setFilterType(3)"><i class="bx bx-filter-alt"></i> Owners </a>
        <a type="button" class="btn btn-primary bg-gray" @click="capturarTela()"><i class="bx bx-image"></i>
          Capturar imagem </a>

      </div>
    </div>
    <div class="col-12 zoom-out-80" v-if="items.length > 0">
      <ul class="list-group list-heads" style="width:400px">
        <li>
          <div><strong>Agrupado por {{ filterName }}</strong></div>
        </li>
        <li v-for="(item, index) of items" :key="`key-${index}`"
          >
          <div class="text-white " :class="getCssClasse(item.value, index)">
            <p class="mb-0"><a class="btn-open-close" @click="showHideList(index)">
              <i class="bx bx-chevron-up" v-if="!showHidenItems.includes(index)"></i>
              <i class="bx bx-chevron-down" v-else></i>
            </a>
              {{ item.value }}</p>
            <span class="count-itens">{{ item.ids }}</span>

          </div>

          <ul v-if="item.tasks.length > 0"  v-show="!showHidenItems.includes(index)">
            <li v-for="(task, taskIndex) in item.tasks" :key="`task-name-${taskIndex}`">

              <p>
                <span class="text-color item-in-list">{{ task.task_name | limited(40) }}</span>
                <i>Formato: {{ getFormatoName(task.formato_formato) }} </i>
              </p>
              <button type="button" class="btn btn-table-pauta btn-success"
                @click="openForm(task.task_bucket_id, task.task_id)">
                <i class="bx bx-link-external"></i>
              </button>
            </li>
          </ul>
        </li>
        <li>
          <div><strong>Agrupado por {{ filterName }}</strong></div>
        </li>
      </ul>
      <ul class="list-group inline-list">
        <!-- headers -->
        <li style="height:65px">
          <ul class='list-heads' v-bind:style="{ width: 180 * setHeaders.length + 'px' }">
            <li v-for="bp in setHeaders" :key="bp.key" style="height:65px">
              <div><strong>{{ bp.title }}</strong></div>
            </li>
          </ul>
        </li>
        <!-- grupos -->
        <li v-for="(re, index) of items" :key="`lis-${index}`">
          <!-- vazio -->
          <ul
            v-bind:style="{ width: 180 * setHeaders.length + 'px', position: 'relative', float: 'left', opacity: '.5', height: '65px' }"
            :class="getCssClasse(re.value, index)">
          </ul>
          <!-- items -->
          <ul class="has-result" v-bind:style="{ width: 180 * setHeaders.length + 'px', height: '65px' }"
            v-for="(task, taskIndex) of re.tasks" :key="`task-${taskIndex}-${task.id}`" :data-show-hidden="{ index }"
            v-show="!showHidenItems.includes(index)">
            <li v-for="(v, vIndex) of setHeaders" :key="`task-${vIndex}-${task.id}`">
              <div>
                <template v-if="v.key === 'formato_status' || v.key === 'formato_data_mes'">
                  <template v-if="v.key === 'formato_data_mes'">
                    {{ getNomeMes(task[v.key]) }}
                  </template>
                  <template v-else>
                    {{ getNomeStatus(task[v.key]) }}
                  </template>
                </template>

                <template v-else>
                  {{ task[v.key] }}
                </template>
              </div>
            </li>
          </ul>
        </li>
        <!-- headers -->
        <li style="height:65px">
          <ul class='list-heads' v-bind:style="{ width: 180 * setHeaders.length + 'px' }">
            <li v-for="bp in setHeaders" :key="bp.key" style="height:65px">
              <div><strong>{{ bp.title }}</strong></div>
            </li>
          </ul>
        </li>

      </ul>
    </div>
  </div>
</template>

<script>
import { status, meses, formatos } from '../../../data/data-static.js'
import html2canvas from 'html2canvas';
export default {
  name: "Pauta",
  props: {
    userAdmin: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      filterType: 1,
      filterName: 'Status',
      boardProperties: null,
      columSize: 250,
      showHidenItems: [],
      items: [],
      idsList: [],
      peoplesList: [],
      ownersList: [],
      statusList: [],
      setHeaders: [
        {
          title: 'Entrada de Briefing',
          key: 'formato_data_entrada_briefing'
        },
        {
          title: 'Entrada',
          key: 'formato_data_entrada'
        },
        {
          title: 'Mês',
          key: 'formato_data_mes'
        },
        {
          title: 'Saída',
          key: 'formato_data_saida'
        },
        {
          title: 'Status',
          key: 'formato_status'
        },
        {
          title: 'Quantidade',
          key: 'formato_qtda'
        },
        {
          title: 'Versão',
          key: 'formato_versionamento'
        },
      ]
    };
  },
  async mounted() {
    const options = this.$getAPIHeaders(
      "GET",
      `task-properties-all-pauta/${this.$route.params.id}`
    );

    try {
      const response = await this.axios(options);
      //this.items = response.data.data;
      console.log('data', response.data.data)
      await this.setPeoples(response.data.data);
      await this.setOwners(response.data.data);
      await this.setStatus(response.data.data);
      await this.initializePauta();
    } catch (error) {
      console.error(error);
    }
  },
  watch: {
    filterType: "initializePauta"
  },
  methods: {
    showHideList(index) {
      let temp = this.showHidenItems;
      let show = temp.includes(index)
      if (!show) {
        this.showHidenItems.push(index)
      } else {
        let some = this.showHidenItems.filter(e => e != index)
        this.showHidenItems = some
      }
    },
    openForm(bucket, id) {
      this.$emit("openForm", bucket, id);
    },
    getCssClasse(value, index) {
      if (this.filterType === 1) {
        return `tag-${index}`
      } else {
        return `named- ${value[0]}`
      }

    },
    async initializePauta() {
      //Por status na demanda
      if (this.filterType === 1) {
        this.items = this.statusList
      }
      //Pessoas
      else if (this.filterType === 2) {
        this.items = this.peoplesList
      }
      else {
        this.items = this.ownersList
      }
    },
    setFilterType(nfilter) {

      if (nfilter === 1) {
        this.filterName = 'Status'
      } else if (nfilter === 2) {
        this.filterName = 'Pessoas'
      } else {
        this.filterName = 'Owners'
      }
      this.filterType = nfilter;
    },
    getFormatoName(id) {
      const found = formatos.find(f => f.id == id);
      return found ? found.value : '';
    },
    getNomeStatus(val) {
      let id = Number(val);
      const found = status.find(f => f.id == id);
      return found ? found.value : '';
    },
    getNomeMes(id) {

      const found = meses.find(f => f.id == id);
      return found ? found.value : '';

    },
    async setStatus(data) {
      const statusList = status.map(item => ({
        ...item,
        tasks: []
      }));

      data.forEach(item => {
        const statusItem = statusList.find(status => parseInt(status.id) === item.formato_status);
        if (statusItem) {
          statusItem.tasks.push(item);
        }
      })
      let filtrados = statusList.filter(status => status.tasks.length > 0);
      this.statusList = await this.getIds(filtrados);
      console.log('status list ok, ', this.statusList)
      return true;

    },
    async setOwners(data) {
      if (!data) {
        console.error('Nada para procurar');
        return;
      }

      let owners = data.map(item => {
        const owner = item.task_owner;

        if (owner && typeof owner === 'object') {
          return {
            id: parseInt(owner.value),
            value: owner.real_value,
            tasks: []
          };
        } else if (owner !== null && owner !== undefined) {
          return {
            id: null,
            value: owner,
            tasks: []
          };
        }

        return null;
      });

      owners = owners.filter(Boolean);
      owners = Object.values(
        owners.reduce((acc, owner) => {
          const key = `${owner.id}-${owner.value}`;
          acc[key] = acc[key] || owner;
          return acc;
        }, {})
      );

      //owners.sort((a, b) => a.value.localeCompare(b.value));

      data.forEach(item => {
        const owner = item.task_owner;
        if (owner === null || owner === undefined) {
          return;
        }
        const key = typeof owner === 'object'
          ? `${parseInt(owner.value)}-${owner.real_value}`
          : `null-${owner}`;
        const ownerItem = owners.find(o => `${o.id}-${o.value}` === key);
        if (ownerItem) {
          ownerItem.tasks.push(item);
        }
      });
      
      this.ownersList = await this.getIds(owners);
      console.log('owner list ok, ', this.ownersList);
      return true;
    },
    async setPeoples(data) {
      if (!data) {
        console.error('Nada para procurar');
        return;
      }
      let pessoas = data.flatMap(item => {
        return item.task_users.map(user => ({
          id: user.id,
          value: user.name,
          tasks: []
        }));
      });
      pessoas = Object.values(
        pessoas.reduce((acc, pessoa) => {
          acc[pessoa.id] = acc[pessoa.id] || pessoa;
          return acc;
        }, {})
      );
      //pessoas.sort((a, b) => a.value.localeCompare(b.value));
      data.forEach(task => {
        task.task_users.forEach(user => {
          const pessoa = pessoas.find(p => p.id === user.id);
          if (pessoa) {
            pessoa.tasks.push(task);
          }
        });
      });

      this.peoplesList = await this.getIds(pessoas);
      
      console.log('Poeples list ok, ', this.peoplesList);
      return true;

    },
    async getIds(data){
      return data.map(item => {
          const ids = [];
          item.tasks.forEach(task => {
            if(!ids.includes(task.task_id)){
              ids.push(task.task_id)
            }
          })
          return {
            ...item,
            ids: ids.length
          }
      })
    },
    async capturarTela() {
      html2canvas(document.body, {
        scrollY: -window.scrollY
      }).then(canvas => {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'captura-pagina.png';
        link.click();
      });
    }
  }
};
</script>
<style>
.hidden {
  display: none !important;
}

.btn-open-close {
  width: 20px;
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  background: #FFF;
  color: #000;
  border-radius: 4px;
  display: inline-block;
  margin-right: 10px;
  text-align: center;
}

.count-itens {
  width: 30px;
  height: 30px;
  background: #3b5de7;
  color: #FFF;
  font-size: 12px;
  line-height: 30px;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
}

.list-group {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

.list-group li {
  padding: 0;
  min-height: 65px;
  border-right: 1px solid #f1f2f4;
}

.list-heads,
.inline-list {
  position: relative;
  float: left;
  width: 30%;
}

.list-heads>li>div,
.list-heads>li>ul>li,
.has-result>li {
  padding: 0.75rem 0.75rem;
  height: 65px;
}

.list-heads>li>div,
.has-result>li>div {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}

.has-result>li>div {
  height: 100%;
}

.inline-list {
  width: calc(100% - 400px);
  overflow-x: auto;
  background: #FFF;
}

.inline-list>li {
  padding: 0px;
  height: auto;
}

.inline-list>li>ul,
.list-heads>li>ul {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

.list-heads>li>ul>li,
.inline-list>li>ul>li {
  height: 65px;
}

.inline-list>li>ul>li {
  position: relative;
  float: left;
  width: 180px;
  overflow: hidden;
  text-wrap: nowrap;
}

li:hover>.btn-table-pauta {
  display: block;
}

li>.btn-table-pauta {
  font-size: 10px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  padding: 0px;
  font-size: 14px;
  display: none;
}

/* 
colors
*/
ul.list-heads>li:first-child,
ul.list-heads>li:last-child,
ul.inline-list>li:first-child {
  background-color: #fff;
  color: #333 !important;
}

ul.list-heads>li:first-child {
  -webkit-border-top-left-radius: 4px;
  -moz-border-radius-topleft: 4px;
  border-top-left-radius: 4px;
}

ul.list-heads>li:last-child {
  -webkit-border-bottom-left-radius: 4px;
  -moz-border-radius-bottomleft: 4px;
  border-bottom-left-radius: 4px;
}

ul.inline-list>li:first-child>ul>li,
ul.inline-list>li:last-child>ul>li {
  background-color: rgba(255, 255, 255, 0.7);
  color: #333 !important;
}

ul.inline-list>li:first-child>ul>li:last-child {
  -webkit-border-top-right-radius: 4px;
  -moz-border-radius-topright: 4px;
  border-top-right-radius: 4px;
}

ul.inline-list>li:last-child>ul>li:last-child {
  -webkit-border-bottom-right-radius: 4px;
  -moz-border-radius-bottomright: 4px;
  border-bottom-right-radius: 4px;
}

.list-heads li>ul>li {
  background: #f1f2f4;
  display: flex;
}

.list-heads li>ul>li:nth-child(odd) {
  background: #fff;
}

li>ul.has-result>li {
  background: #fff;
}

li>ul.has-result:nth-child(odd)>li {
  background: #f1f2f4;
}

.my-badge {
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  margin-top: 5px;
  display: inline-block;
  padding: 4px 6px;
  line-height: 1;
  max-width: 100%;
  text-wrap: nowrap;
  overflow: hidden;
}


.pr-0 {
  padding-right: 0px !important;
}

.pl-0 {
  padding-left: 0px !important;
}

.scrrollable {
  overflow: scroll !important;
  white-space: nowrap !important;
}

.my-table-heads th,
.my-table-heads td,
.my-table-pauta th,
.my-table-pauta td {
  height: 46px !important;
}

.my-table-heads td.title {
  color: #3b5de7;
}

.item-in-list {
  position: relative;
  float: left;
  width: 90%;
  overflow: hidden;
  margin: 0px;
  padding: 0px;
  text-wrap: nowrap;
  overflow-wrap: unset;
}

.my-table-heads th:first-child {
  -webkit-border-top-left-radius: 10px;
  -moz-border-radius-topleft: 10px;
  border-top-left-radius: 10px;
}

.my-table-pauta th:last-child {
  -webkit-border-top-right-radius: 10px;
  -moz-border-radius-topright: 10px;
  border-top-right-radius: 10px;
}

li>p {
  float: left;
  width: 100%;
}

.bg-dark-subtle {
  background: #FFF !important;
}
</style>